exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sidebar-minimizer .ml-auto[data-v-61adcc70]{float:left;color:#fff;padding-left:15px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Sidebar/SidebarMinimizer.vue"],"names":[],"mappings":"AACA,6CACE,WAAY,AACZ,WAAY,AACZ,iBAAmB,CACpB","file":"SidebarMinimizer.vue","sourcesContent":["\n.sidebar-minimizer .ml-auto[data-v-61adcc70]{\n  float: left;\n  color: #fff;\n  padding-left: 15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61adcc70","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar/SidebarMinimizer.vue
// module id = 1417
// module chunks = 0